import { Navigate, useLocation } from "react-router";
import { pathOfRenamedSection } from "../shared/routing/appPaths";

/** An address from before a section was renamed (WA-7's Documents, WA-10's Data model): the
 * same place, with its query and fragment, under its new name. */
export default function LegacySectionRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={pathOfRenamedSection(pathname, search, hash)} replace={true} />;
}
